/** 5000 → "$5.000" (pesos colombianos, sin decimales). */
export function pesos(valor: number | null | undefined): string {
  if (valor == null) return "—";
  const signo = valor < 0 ? "−" : "";
  const absoluto = Math.round(Math.abs(valor))
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  return `${signo}$${absoluto}`;
}

/** Hora corta en Bogotá: "4:05 p. m." */
export function hora(fecha: string | Date | null | undefined): string {
  if (!fecha) return "—";
  return new Date(fecha).toLocaleTimeString("es-CO", {
    hour: "numeric",
    minute: "2-digit",
    timeZone: "America/Bogota",
  });
}

/** "hace 5 min", "hace 2 h", "hace 3 días". */
export function hace(fecha: string | Date, ahora: Date = new Date()): string {
  const minutos = Math.max(0, Math.floor((ahora.getTime() - new Date(fecha).getTime()) / 60000));
  if (minutos < 1) return "ahora";
  if (minutos < 60) return `hace ${minutos} min`;
  const horas = Math.floor(minutos / 60);
  if (horas < 24) return `hace ${horas} h`;
  const dias = Math.floor(horas / 24);
  return `hace ${dias} ${dias === 1 ? "día" : "días"}`;
}
